import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { StageSelectorQuery, SelectedStageSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { dedupe } from '@/helpers/dedupe'
import { useCombobox } from '@/helpers/useCombobox'

type Stage = SelectedStageSelectorQuery['events']['nodes'][0]['eventStages']['nodes'][0]

interface Props {
  eventId: string
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ eventId, value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedStageSelectorQuery>(
    SelectedQuery,
    { variables: { eventId, id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<StageSelectorQuery>(
    Query,
    { variables: { eventId, first: 10 } }
  )

  const { pageInfo, items } = useCombobox<Stage>({
    pageInfo: data?.events.nodes[0].eventStages.pageInfo,
    querySelected: selectedData?.events.nodes[0].eventStages.nodes[0],
    queryCollection: data?.events.nodes[0].eventStages.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.events.nodes[0].eventStages.nodes = dedupe([
            ...previousData.events.nodes[0].eventStages.nodes,
            ...fetchMoreResult.events.nodes[0].eventStages.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
